module.exports = __webpack_public_path__ + "img/palm-room-2.429a36fc.jpg";